import React from "react";
import Youtube from "@components/Youtube";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const Anniversary = () => {
    const [anniversary, setAnniversary] = useState([]);
  
    useEffect(() => {
      fetchAnniversary();
    }, []);
  
    const fetchAnniversary = async () => {
      try {
        const response = await fetch("https://cms.okoce.net/api/admin/anniversaries");
        if (!response.ok) {
          throw new Error("Gagal mengambil data anniversary");
        }
        const data = await response.json();
        setAnniversary(data.data[0] || []);
      } catch (error) {
        setAnniversary([]);
      }
    };

    return (
        <>
            <div className="mt-[6rem] bg-[#1c75ac] w-full h-[20rem] grid justify-center content-center text-white">
                <h1 className="font-extrabold text-4xl text-center">{anniversary.title}</h1>
                <div className="text-center mt-6 px-2" dangerouslySetInnerHTML={{ __html: anniversary.description }} />
            </div>
            <div className="flex justify-center m-12">
                <Youtube src={anniversary.url} />
            </div>
            <FloatingMenu />{" "}
        </>
    );
}

export default Anniversary;